import styled from 'styled-components';
import { FuelIcon } from '@frete.com/fuel-react';

export const Container = styled.div<{ error: boolean }>`
  width: 100%;
  }
`;

export const Label = styled.label<{ error: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing.km1};
  font-weight: ${({ theme }) => theme.font.weight.bold};

  color: ${({ theme, error }) =>
    error ? theme.color.text.danger.default : theme.color.text.neutral.strong};
`;

export const Content = styled.div<{ error: boolean }>`
  position: relative;
  display: flex;
  width: 100%;
`;

export const Input = styled.input<{ error: boolean }>`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.km3};
  padding-right: ${({ theme }) => theme.spacing.km10};
  border: 1px solid
    ${({ theme, error }) =>
      error
        ? theme.color.border.danger.default
        : theme.color.border.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.large};
  outline: none;

  &::placeholder {
    color: ${({ theme, error }) =>
      error ? theme.color.text.neutral.strong : theme.color.text.neutral.weak};
  }
`;

export const Icon = styled(FuelIcon)`
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  right: 22px;
  color: ${({ theme }) => theme.color.icon.danger.default};
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.color.icon.danger.default};
  margin-bottom: ${({ theme }) => theme.spacing.km2};
  font-size: ${({ theme }) => theme.spacing.km3};
`;
